module.exports = __webpack_public_path__ + "img/待确认.f9200ba1.jpg";